// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610200405/js/" + chunkId + "." + {"44":"42191b57","225":"9a6e7798","481":"e8e68b15","486":"87fc1298","770":"b31a5481"}[chunkId] + ".0.3708772248973926.chunk.js";
};